import profile from "../assets/images/profile_1.jpg";

function AboutMe() {
  return (
    <div>
      <img
        className="rounded-full"
        src={profile}
        alt="Profile"
        title="Profile"
      />
      <p>It's a me!</p>
    </div>
  );
}

export default AboutMe;
